import { theme } from '@frontend/theme';

export const toolbarStyling = {
  display: 'flex',
  alignItems: 'center',
  columnGap: theme.spacing(1),
  padding: theme.spacing(1),
  background: theme.colors.white,
  boxShadow: theme.shadows.light,
  border: `solid 1px transparent`,
  borderRadius: theme.borderRadius.small,
  transition: 'all 250ms ease',

  '&:hover, &:focus': {
    outline: 'none',
    boxShadow: theme.shadows.floating,
    background: theme.colors.neutral5,
  },
};

export const iconStyling = {
  height: theme.spacing(2),
  width: theme.spacing(2),
  minHeight: theme.spacing(2),
  minWidth: theme.spacing(2),
};
